import { CATEGORY_ALL } from "../discover/discoverConstants";

/**
 * URL의 인코딩된 카테고리 이름을 디코딩합니다.
 * @param {string} partiallyEncodedName - 인코딩된 이름
 * @returns {string} 디코딩된 이름
 */
export function decodeCategoryName(partiallyEncodedName) {
    try {
        return decodeURIComponent(partiallyEncodedName);
    } catch (e) {
        return partiallyEncodedName;
    }
}

/**
 * GraphQL 데이터에서 모든 카테고리 목록을 추출합니다.
 * @param {object} data - useQuery에서 반환된 데이터
 * @returns {Array} 카테고리 배열
 */
export function getAllCategories(data) {
    if (!data || !data.getCategoriesCached) return [];
    return data.getCategoriesCached;
}

/**
 * 전체 카테고리 목록과 현재 카테고리 이름으로 선택된 카테고리 객체를 찾습니다.
 * @param {Array} categories - 전체 카테고리 배열
 * @param {string} categoryName - 찾고자 하는 카테고리 이름
 * @returns {object} 선택된 카테고리 객체 또는 기본값
 */
export function getSelectedCategory(categories, categoryName) {
    if (!categories || !categoryName) return CATEGORY_ALL;
    const category = categories.find(c => c.name === categoryName);
    return category || CATEGORY_ALL;
}
